import React, { createContext, useCallback, useState } from "react"
import { TZyomuinGetRes } from "../../../service/driver/TZyomuin"
import { 区分マスタ } from "../../../service/master/kubun/TKubun"
import { T点呼ヘッダ情報 } from "../../../service/tablet/TTabletTenko"
import {
  TTenkoDetailInfoGetRes,
  TTenkoDetailUpsertReq,
} from "../../../service/truckcontrol/tenko/TTenko"
import { useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TenkoService from "../../../service/truckcontrol/tenko/tenkoService"
import { TApiResponse } from "../../../service/TApiResponse"
import { useHistory } from "react-router-dom"
import { selectTenkoTypePage } from "../../../constant/tablet/pages"
import { showToast } from "../../../components/Tablet/TabletToast"
import { e点呼区分, e点呼方法区分 } from "../../../constant/enum/unko"

export const TenkoHeaderContext = createContext<{
  点呼ヘッダ情報: T点呼ヘッダ情報 | undefined
  set点呼ヘッダ情報: React.Dispatch<
    React.SetStateAction<T点呼ヘッダ情報 | undefined>
  >
}>({ 点呼ヘッダ情報: {}, set点呼ヘッダ情報: () => {} })

export const TenkoHohoKubunContext = createContext<{
  点呼方法区分: 区分マスタ | undefined
  set点呼方法区分: React.Dispatch<React.SetStateAction<区分マスタ | undefined>>
}>({ 点呼方法区分: undefined, set点呼方法区分: () => {} })

export const TenkoKubunContext = createContext<{
  点呼区分: 区分マスタ | undefined
  set点呼区分: React.Dispatch<React.SetStateAction<区分マスタ | undefined>>
}>({ 点呼区分: undefined, set点呼区分: () => {} })

export const TenkoCountContext = createContext<{
  点呼回数: number
  set点呼回数: React.Dispatch<React.SetStateAction<number>>
}>({ 点呼回数: 1, set点呼回数: () => {} })

export const ZyomuinContext = createContext<{
  乗務員: TZyomuinGetRes | undefined
  set乗務員: React.Dispatch<React.SetStateAction<TZyomuinGetRes | undefined>>
}>({ 乗務員: undefined, set乗務員: () => {} })

export const TenkoDetailContext = createContext<{
  点呼明細: TTenkoDetailUpsertReq | undefined
  set点呼明細: React.Dispatch<
    React.SetStateAction<TTenkoDetailUpsertReq | undefined>
  >
}>({ 点呼明細: undefined, set点呼明細: () => {} })

export const UpsertTenkoDetailFunctionContext = createContext<
  (
    newData?: Partial<TTenkoDetailUpsertReq>,
    DoNotMoveFlg?: boolean
  ) => Promise<TApiResponse<TTenkoDetailInfoGetRes> | null>
>(async (newData?: Partial<TTenkoDetailUpsertReq>) => {
  return null
})

export const useTabletContexts = () => {
  const history = useHistory()
  const 点呼者 = useSelector((root: RootState) => root.user.LoginUserInfo)

  const [点呼ヘッダ情報, set点呼ヘッダ情報] = useState<T点呼ヘッダ情報>()
  const [点呼方法区分, set点呼方法区分] = useState<区分マスタ>()
  const [点呼区分, set点呼区分] = useState<区分マスタ>()
  const [点呼回数, set点呼回数] = useState<number>(1)
  const [乗務員, set乗務員] = useState<TZyomuinGetRes>()
  const [点呼明細, set点呼明細] = useState<TTenkoDetailUpsertReq>()

  const initContexts = () => {
    set点呼ヘッダ情報(undefined)
    set点呼方法区分(undefined)
    set点呼区分(undefined)
    set点呼回数(1)
    set乗務員(undefined)
  }

  const upsertTenkoDetail = useCallback(
    async (
      newData?: Partial<TTenkoDetailUpsertReq>,
      DoNotMoveFlg?: boolean
    ) => {
      if (乗務員?.乗務員ID == null) {
        throw new Error("乗務員が取得できません")
      }

      try {
        // 現状のヘッダ情報等を含めて点呼明細を作成
        const upsertData: TTenkoDetailUpsertReq = {
          ...点呼明細,
          ...newData,
          点呼回数,
          // 乗務員情報
          乗務員ID: 乗務員.乗務員ID,
          乗務員社員番号: 乗務員?.社員コード,
          部所ID: 乗務員.部所ID,
          // 点呼者情報
          点呼執行者社員ID: 点呼者.社員ID,
          点呼執行者社員番号: 点呼者.社員コード,
          点呼執行者社員氏名: 点呼者.社員氏名,
          点呼区分コード: 点呼区分?.区分コード,
          点呼方法区分コード: 点呼方法区分?.区分コード,
          // ヘッダ項目
          点呼日: 点呼ヘッダ情報?.点呼日,
          // 登録時の時刻を登録
          実点呼日: new Date().toISOString(),
          点呼時刻: new Date().toISOString(),
          点呼記録ID: 点呼ヘッダ情報?.点呼記録ID,
          天候区分コード: 点呼ヘッダ情報?.天候区分コード,
          共通指示事項1区分ID: 点呼ヘッダ情報?.共通指示事項1区分ID,
          共通指示事項1テキスト: 点呼ヘッダ情報?.共通指示事項1テキスト,
          共通指示事項2テキスト: 点呼ヘッダ情報?.共通指示事項2テキスト,
        }

        // 中間点呼の場合のみ点呼方法区分は電話固定
        if (
          [
            e点呼区分.中間点呼１,
            e点呼区分.中間点呼２,
            e点呼区分.中間点呼３,
          ].find((e) => e === 点呼区分?.区分コード) != null
        ) {
          upsertData.点呼方法区分コード = e点呼方法区分.電話
        }

        const tenkoService = new TenkoService()

        // 車番を取得
        const 点呼一覧Res = await tenkoService.getList({
          日付: 点呼ヘッダ情報?.点呼日,
          部所コード: 乗務員.部所コード,
          乗務員ID: 乗務員.乗務員ID,
        })
        if (
          点呼一覧Res.data &&
          点呼一覧Res.data.length > 0 &&
          点呼一覧Res.data[0] != null
        ) {
          upsertData.車番 = 点呼一覧Res.data[0].車番
          upsertData.トレーラ車番 = 点呼一覧Res.data[0].トレーラ車番
        } else {
          upsertData.車番 = undefined
          upsertData.トレーラ車番 = undefined
        }

        const res = await tenkoService.putTenko(upsertData)

        // 基本的に登録が終わったら点呼方法選択に遷移
        if (res != null && !DoNotMoveFlg) {
          showToast(
            [
              ``,
              `${乗務員?.社員氏名}さんの`,
              `${点呼区分?.名称1}を`,
              "完了しました",
            ],
            {
              bodyStyle: { fontSize: "2rem" },
            }
          )
          //点呼明細を初期化
          set点呼明細(undefined)
          history.push(selectTenkoTypePage.Route.path)
        } else {
          // 点呼方法選択に遷移しない場合、情報を上書きする可能性があるので返却値で点呼明細を更新する
          set点呼明細(res.data)
        }
        console.log(res, "font-size:4rem; color:green;")
        return res
      } catch (error) {
        throw error
      }
    },
    [
      history,
      点呼回数,
      乗務員?.乗務員ID,
      乗務員?.社員コード,
      乗務員?.社員氏名,
      乗務員?.部所ID,
      乗務員?.部所コード,
      点呼ヘッダ情報?.共通指示事項1区分ID,
      点呼ヘッダ情報?.共通指示事項1テキスト,
      点呼ヘッダ情報?.共通指示事項2テキスト,
      点呼ヘッダ情報?.天候区分コード,
      点呼ヘッダ情報?.点呼日,
      点呼ヘッダ情報?.点呼記録ID,
      点呼区分?.区分コード,
      点呼区分?.名称1,
      点呼方法区分,
      点呼明細,
      点呼者.社員ID,
      点呼者.社員コード,
      点呼者.社員氏名,
    ]
  )

  return {
    initContexts,
    Component: React.memo(({ children }) => (
      <TenkoHeaderContext.Provider
        value={{
          点呼ヘッダ情報,
          set点呼ヘッダ情報,
        }}>
        <TenkoHohoKubunContext.Provider
          value={{
            点呼方法区分,
            set点呼方法区分,
          }}>
          <TenkoKubunContext.Provider value={{ 点呼区分, set点呼区分 }}>
            <TenkoCountContext.Provider value={{ 点呼回数, set点呼回数 }}>
              <ZyomuinContext.Provider
                value={{
                  乗務員,
                  set乗務員,
                }}>
                <TenkoDetailContext.Provider
                  value={{
                    点呼明細,
                    set点呼明細,
                  }}>
                  <UpsertTenkoDetailFunctionContext.Provider
                    value={upsertTenkoDetail}>
                    {children}
                  </UpsertTenkoDetailFunctionContext.Provider>
                </TenkoDetailContext.Provider>
              </ZyomuinContext.Provider>
            </TenkoCountContext.Provider>
          </TenkoKubunContext.Provider>
        </TenkoHohoKubunContext.Provider>
      </TenkoHeaderContext.Provider>
    )),
  }
}
